import { Component, OnInit, Input } from '@angular/core';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { ClientNote } from 'src/app/clients-module/models/clientLocation';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { FilteringService } from 'src/app/services/filtering.service';
import { NotesService } from './Services/notes.service';

@Component({
  selector: 'app-notes-pane',
  templateUrl: './notes-pane.component.html',
  styleUrls: ['./notes-pane.component.less']
})
export class NotesPaneComponent implements OnInit {
  @Input() clientId : number;
  @Input() locationId : number;

  newNote : ClientNote = new ClientNote();

  
  constructor(public notes : NotesService, public auth : AuthService, public toastr : ToastrService, public filtering : FilteringService) { }

  ngOnInit() {
    this.newNote.userId = this.auth.loggedInUser.id;
    this.newNote.clientId = this.clientId;
    this.newNote.locationId = this.locationId;

    if(this.locationId > 0) {
      this.notes.GetNotes(this.locationId, true);
    }
    else {
      this.notes.GetNotes(this.clientId);
    }
  }
  
  saveNote(){
    if(this.newNote.note == undefined || this.newNote.note == "") {
      this.toastr.error('Empty notes cannot be saved.', '', { disableTimeOut: true, closeButton: true});
      
    } else {
      this.notes.SaveNote(this.newNote, this.notes.notes);
      this.newNote = new ClientNote();
      this.newNote.userId = this.auth.loggedInUser.id;
      this.newNote.clientId = this.clientId;
      this.newNote.locationId = this.locationId;
    }
  }

  public get GetNotesArray() : ClientNote[] {
    return this.notes.notes;
  }

  setNoteType(tp : number) {
    this.newNote.noteType = tp;
  }

  getNoteType(val : number){
    if(val > 0) return this.notes.clientNoteTypes.find(t =>{ return t.id == val;}).className;
    else return '';
   }
}
